export class CaseShards {
	caseId: string;
	primaryShardCount: number;
	replicaShardCount: number;
	replicaPerPrimary: number;
	avgPrimaryBytes: number;
	avgReplicaBytes: number;
}
